import { IAtgard } from "~app/features/planera/model/IAtgard";

export class AtgardUtbyteBehaviour {

    static readonly GrotFaktor = 0.12;

    constructor(private readonly atgard: IAtgard) { }

    get direktUtbyteGrot(): number {
        if (!this.atgard || !this.atgard.grotuttagProduktionsplanerat) {
            return 0;
        }

        return Math.round(AtgardUtbyteBehaviour.GrotFaktor * this.direktUtbyteRundvirke);
    }

    get direktUtbyteRundvirke(): number {
        return this.atgard.utbytesberakningar.reduce((total, utbyte) => total + utbyte.volymM3fub, 0);
    }
}
